import {
  Box,
  ButtonIcon,
  Icon,
  SidePanel,
  TabContent,
  TabGroup,
  TabItem,
} from "@saviynt/design-system";
import cx from "classnames";

import { PolicyTypeIcon } from "../PoliciesPageList/CellRenderer/CellRenderer";
import { capitalizeFirstLetter } from "@repo/mfe-core";
import { useIntl } from "react-intl";
import "./PoliciesSidepanel.css";
import { SOURCE_TYPES } from "../../constants/policies.constants";
import SummaryTab from "./SummaryTab/SummaryTab";
import { useState, SetStateAction } from "react";
import { useGetPolicyById } from "../../hooks/usePolicy";
import { VariantType } from "../PoliciesForm/InventorySidePanel/InventorySidePanel";
interface PoliciesSidepanelProps {
  bridgePosition?: { top: number; left: number; height: number };
  isOpen: boolean;
  closeSidepanel: () => void;
  className?: string;
  policyData: { id: string; name: string };
  variant: VariantType;
  isCloseButtonHidden?: boolean;
}

export const getApplicationSourceIcon = (source: string) => {
  return SOURCE_TYPES.includes(source)
    ? source.toLocaleUpperCase()
    : capitalizeFirstLetter(source);
};

export default function PoliciesSidepanel({
  bridgePosition,
  isOpen,
  closeSidepanel,
  policyData,
  isCloseButtonHidden,
  className,
}: PoliciesSidepanelProps) {
  const intl = useIntl();
  const [activeTab, setActiveTab] = useState("1");
  const handleChange = (value: SetStateAction<string>) => {
    setActiveTab(value);
  };

  const { data: policyDetails } = useGetPolicyById(policyData.id);

  const sidepanelContent = (
    <Box>
      <TabGroup value={activeTab} onChange={handleChange}>
        <TabItem
          label={intl.formatMessage({
            id: "RrCui3",
            defaultMessage: "Summary",
          })}
          value="1"
          icon={<Icon kind="Document" size="medium" />}
        />
      </TabGroup>
      <TabContent value={activeTab} tabValue="1">
        <SummaryTab policyDetails={policyDetails} />
      </TabContent>
    </Box>
  );

  const renderHeaderIcon = (isCustomPolicy: boolean) => {
    const icon = <PolicyTypeIcon isCustomPolicy={isCustomPolicy} />;

    if (!isCloseButtonHidden) return icon;

    return (
      <div className="flex">
        <ButtonIcon
          size="large"
          kind="ghost"
          icon={<Icon kind="ChevronLeft" size="medium" />}
          onClick={closeSidepanel}
          ariaLabel={intl.formatMessage({
            defaultMessage: "Back",
            id: "4bsr8c",
            description: "Aria label for back button",
          })}
          dataTestId="NHI-Findings-Summary-SidePanel-Back-Button"
        />
        {icon}
      </div>
    );
  };

  return (
    <Box
      className="PoliciesList-Table-SidePanel"
      style={
        {
          "--bridge-top": `${bridgePosition?.top || 0}px`,
          "--bridge-height": `${bridgePosition?.height || 0}px`,
        } as React.CSSProperties
      }
    >
      <SidePanel
        header={{
          title: policyDetails?.name ?? policyData.name,
          description: policyDetails?.category,
          headerIcon: renderHeaderIcon(policyDetails?.is_custom ?? false),
        }}
        layout={sidepanelContent}
        isOpen={isOpen}
        onClose={closeSidepanel}
        isSidePanelNavigatingList={false}
        className={cx("PoliciesList-SidePanel", className, "with-bridge", {
          "PoliciesList-SidePanel--noCloseButton": isCloseButtonHidden,
        })}
        classNames={{
          layoutClassName: "PoliciesList-SidePanel-layout",
          headerClassName: "PoliciesList-SidePanel-header",
        }}
      />
    </Box>
  );
}
